import Typography from "_components/atoms/typography";
import Icon       from "_components/atoms/icon";
import Image      from "_components/atoms/image";
import Parser     from "_components/atoms/htmlParser";
import useStyles  from "./styles";

const Component = props => {
	const { feedItem, handleNotificationClick, activeUpdateTab, marked, isNotificationsPage } = props;

	const { classes } = useStyles (
		{
			viewed: activeUpdateTab ? 1 : marked ? marked : feedItem?.viewed ?? 1,
			activeUpdateTab,
			isNotificationsPage
		}
	);

	return (
		<>
			<div className = { classes.flexContainer }
				onClick = { () => handleNotificationClick ( feedItem ) }
			>
				{
					activeUpdateTab ? null : <CustomOptionIcon iconName = { feedItem?.payload?.icon } />
				}

				<div className = { classes.contentAndTime }>

					<div className = { classes.contentItem }>

						{
							feedItem?.payload?.rooterData?.photo ? (
								<div className = { classes.photoContainer }>
									<Image
										className   = { classes.profilePhoto }
										placeholder = { "" }
										src         = { feedItem?.payload.rooterData.photo }
									/>
								</div>
							) : null
						}

						{
							feedItem?.payload?.title ? (
								<div className = { classes.title }>
									<Parser textString = { feedItem?.payload.title } />
								</div>
							) : null
						}

						{
							feedItem?.payload?.body ? (
								<div className = { classes.subTitle }>
									<Parser
										color      = "secondary"
										textString = { feedItem?.payload.body }
									/>
								</div>
							) : null
						}

						{
							feedItem?.payload?.thumbnail ? (
								<div className = { classes.thumbnailContainer }>
									<Image
										className = { classes.thumbnail }
										placeholder = { "" }
										src = { feedItem?.payload.thumbnail }
									/>
								</div>
							) : null
						}

					</div>

					<Typography
						className = { classes.createdAt }
						color     = "secondary"
						title     = { feedItem?.cAt === "Just Now" ? "0s" : feedItem?.cAt }
					/>
				</div>

			</div>

			<div className = { classes.separatorParent }>
				<div className = { classes.separator } />
			</div>
		</>
	);
};

export default Component;

export const CustomOptionIcon = ( { iconName } ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	switch ( iconName ) {
		case "BELL":
			return (
				<Icon
					sameInBothTheme
					className = { classes.avatar }
					name = "subscribed"
				/>
			);

		case "RECOMMENDATIONS":
			return (
				<Icon
					sameInBothTheme
					className = { classes.avatar }
					name = "notifRecommended"
				/>
			);

		case "USER":
			return (
				<Icon
					sameInBothTheme
					className = { classes.avatar }
					name = "newFollowers"
				/>
			);

		case "FOLLOWERS":
			return (
				<Icon
					sameInBothTheme
					className = { classes.avatar }
					name = "newFollowers" // uses same icon as new followers.
				/>
			);

		case "COMMENT":
			return (
				<Icon
					sameInBothTheme
					className = { classes.avatar }
					name = "newComments"
				/>
			);

		case "LIKE":
			return (
				<Icon
					sameInBothTheme
					className = { classes.avatar }
					name = "notifLikes"
				/>
			);

		case "SHARE":
			return (
				<Icon
					sameInBothTheme
					className = { classes.avatar }
					name = "notifShares"
				/>
			);

		case "stream_summary":
			return (
				<Icon
					sameInBothTheme
					className = { classes.avatar }
					name = "notifStreamSummary"
				/>
			);

		case "daily_growth_reports":
			return (
				<Icon
					sameInBothTheme
					className = { classes.avatar }
					name = "notifStreamSummary" // uses same icon as stream summary.
				/>
			);

		case "MILESTONE":
			return (
				<Icon
					sameInBothTheme
					className = { classes.avatar }
					name = "notifAchievements"
				/>
			);

		case "ALERT":
			return (
				<Icon
					sameInBothTheme
					className = { classes.avatar }
					name = "notifAlerts"
				/>
			);

		case "COINS":
			return (
				<Icon
					sameInBothTheme
					className = { classes.avatar }
					name = "notifCoins"
				/>
			);

		case "DIAMONDS":
			return (
				<Icon
					sameInBothTheme
					className = { classes.avatar }
					name = "notifDiamonds"
				/>
			);

		default:
			return null;
	}
};